export default {
  enums: [
    { id: 'CONFORMITY_CERTIFICATE' },
    { id: 'CONFORMITY_DECLARATION' },
  ]
};
